export const environment = {
  production: false,
  orderApi: 'https://pagosqa.ordenaris.com',
  paymentGateway: 'https://pagosqa.ordenaris.com/assets/o-payment-gateway.js'
};
